import { isRequired } from '../../utils.js';

var universalMetadata = (function (_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? isRequired('type') : _ref$type,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? isRequired('source') : _ref$source;
  return function () {
    return {
      type: type,
      source: source
    };
  };
});

export default universalMetadata;
